import React from "react";
import { imagesData } from "../../../assets/data/mediaRoomData";
import MediaCard from "../../../components/cards/MediaCard";
import styled from "styled-components";

export default function MediaSection() {
	return (
		<section>
			<MediaCardsContainer>
				{imagesData?.map((data) => (
					<MediaCard data={data} />
				))}
			</MediaCardsContainer>
		</section>
	);
}

const MediaCardsContainer = styled.ul`
	display: grid;
	row-gap: 1.5rem;

	@media (min-width: 760px) {
		grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));

		column-gap: 1.5rem;
		row-gap: 1.5rem;
	}
`;
